import workspaceQuery from '../../../graphql/queries/company/CompanyReportTemplateWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/company/CompanyReportTemplateListQuery.graphql';
import instanceQuery from '../../../graphql/queries/company/CompanyReportTemplateQuery.graphql';
import defaultQuery from '../../../graphql/queries/company/CompanyReportTemplateDefault.graphql';
import mutationQuery from '../../../graphql/mutations/company/CompanyReportTemplateMutation.graphql';
import previewQuery from '../../../graphql/mutations/company/CompanyReportTemplatePreviewMutation.graphql';
import fragment from '../../../graphql/fragments/company/ReportTemplateFragment.graphql';
import migrationQuery from '../../../graphql/mutations/company/CompanyReportTemplateMigrationMutation.graphql';

const CompanyReportTemplate = {
  type: 'ReportTemplate',
  title: 'Document Templates',
  formTitle: 'Document Template',
  formUrl: '/Company/DocumentTemplate/Details/',
  workspaceUrl: '/Company/DocumentTemplate/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  preview: previewQuery,
  migrate: migrationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'DOCUMENT_TEMPLATES',
};

export default CompanyReportTemplate;
